import React, { Component } from 'react';
import { connect } from 'react-redux';
import ListItem from '../ListItem/ListItem';
import './Vysilani.css';
import * as api from '../../../api';
import { saveLastLocation } from '../../../redux/actions';
import { VYSILANI_FILTERS, PATH } from '../../../constants';

class Vysilani extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true, // is this used for anything - or just list length is ok?
      list: [],
      selectedFilter: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    api.getVysilaniData().then((data) => {
      this.setState({
        fetching: false,
        list: data.array,
      });
    }).catch(() => {
      // todo - solve error state
    });
    this.props.saveLastLocation(this.props.match.url);
  }

  render() {
    const { selectedFilter } = this.state;
    const { grid } = this.props;

    // items
    let itemsArray = [];
    if (selectedFilter === 0) {
      itemsArray = this.state.list;
    } else {
      // apply filter
      // todo - reference by 'selectedFilter' is not ideal - can be easily broken
      itemsArray = this.state.list.filter(item =>
        item[1].tag.toUpperCase() === VYSILANI_FILTERS[selectedFilter].name.toUpperCase());
    }
    const items = itemsArray.map(item => (
      <ListItem
        key={item[0]}
        grid={grid}
        itemData={item}
      />
    ));

    // filters
    const filters = VYSILANI_FILTERS.map(filter => (
      <button
        key={filter.id}
        className={`filter ${selectedFilter === filter.id ? 'selected' : ''}`}
        onClick={() => {
          this.setState({ selectedFilter: filter.id });
        }}
      >
        <img
          src={`${PATH.IMG}ico/vysilani/filter-${filter.id}.png`}
          alt={filter.name}
        />
        <div
          className="label"
        >
          {filter.name}
        </div>
      </button>
    ));

    // todo - items.length condition is not idea - probably add to separate function and return result
    return (
      <div id="vysilani">
        <div id="vysilani-head">TOTO100LETÍ ve Vysílání ČT</div>
        <div id="vysilani-filters">
          {filters}
        </div>
        {items.length > 0 &&
        <div>
          {items}
        </div>
        }
        {items.length === 0 &&
        <div className="message-empty">
          Pro tuto kategorii nejsou momentálně dostupná žádná videa.
        </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  grid: state.resize.grid,
});

const mapDispatchToProps = dispatch => ({
  saveLastLocation: lastLocation => dispatch(saveLastLocation(lastLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Vysilani);



// WEBPACK FOOTER //
// ./src/components/App/Vysilani/Vysilani.js